
let myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

let baseUrl = process.env.VUE_APP_BASE_URL || "http://localhost:3000"

const setHeaderName = () => {
    let user_data = localStorage.getItem('user_data')
    user_data = JSON.parse(user_data)
    return user_data
}

const fetchService = {

    fetchFunc(path, requestOptions, callback) {

        fetch(baseUrl + path, requestOptions)
            .then(response => {
                if (response.status === 401) {
                    localStorage.removeItem('user_data');
                    window.location.href = '/login';
                    return null;
                }
                return response.text();
            })
            .then(result => {
                if (result) {
                    callback(result)
                } else {
                    callback(null)
                }
            })
            .catch(error => {
                console.log('error', error)
                callback([])
            });

    },

    get(path, callback, headers) {

        let customH = headers ? headers : myHeaders

        let requestOptions = {
            method: 'GET',
            headers: customH,
            credentials: 'include',
            redirect: 'follow'
        };

        this.fetchFunc(path, requestOptions, (res) => {
            callback(res)
        })

    },

    post(path, body, callback, headers) {
        let customH = headers ? headers : myHeaders

        let newBody = body

        if(typeof body == "string") {
            let user_data = setHeaderName()
            newBody = {
                body: JSON.parse(body),
                user: user_data
            }

            newBody = JSON.stringify(newBody)
        }

        let requestOptions = {
            method: 'POST',
            headers: customH,
            credentials: 'include',
            body: newBody,
            redirect: 'follow'
        };

        this.fetchFunc(path, requestOptions, (res) => {
            callback(res)
        })

    },

    postUser(path, body, callback, headers) {
        let customH = headers ? headers : myHeaders

        let requestOptions = {
            method: 'POST',
            headers: customH,
            credentials: 'include',
            body: body,
            redirect: 'follow'
        };

        this.fetchFunc(path, requestOptions, (res) => {
            callback(res)
        })

    }

}

export default fetchService;